var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:_vm.parentClasses},[_c('div',{class:_vm.classes},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab.title,class:[
          _vm.tabClasses,
          index === _vm.selectedIndex
            ? 'text-blue blue-default'
            : 'text-blue-darker border-transparent' ],domProps:{"innerHTML":_vm._s(tab.title)},on:{"click":function($event){return _vm.selectTab(index)}}})}),0)]),_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }